<template>
    <div class="row-pointer">
        <v-row :dense="isDense" cols="12">
            <v-col :cols="col1">Received</v-col>
            <v-col :cols="col2">
                <date_picker label="" icon="mdi-calendar" :isDense="isDense" :fontsize="fontsize" :date="incident.date_received_iso" field="date_received_iso" @updateData="updateData"/> 
            </v-col>
        </v-row>
        <v-row :dense="isDense" cols="12">
            <v-col :cols="col1">Processed by</v-col>
            <v-col :cols="col2">{{this.incident.user_displayname}}</v-col>
        </v-row>
        <v-row :dense="isDense" cols="12">
            <v-col :cols="col1">Guest</v-col>
            <v-col :cols="col2">{{this.incident.guest_displayname}}</v-col>
        </v-row>
        <v-row :dense="isDense" cols="12">
            <v-col :cols="col1">Arrival - departure</v-col>
            <v-col :cols="col2">{{this.incident.date_arrival}} - {{this.incident.date_departure}}
            </v-col>
        </v-row>
        <v-row :dense="isDense" cols="12">
            <v-col :cols="col1">Booking</v-col>
            <v-col :cols="col2">{{this.incident.booking}}</v-col>
        </v-row>
    </div>    
</template>

<script>

import date_picker from '@/components/ui/date_picker.vue';


export default {
    props: {
        incident: {
            type: Object,
            default: function() { return {}; },
        },
        col1:{
            type: Number,
            default: 2
        }, 
        col2:{
            type: Number,
            default: 4
        }, 
        isDense:{
            type: Boolean,
            default: false
        },
        fontsize: {
            type: String,
            default: ''
        }
    },
    components: {
        date_picker,
    }, 
    data() {
        return {
            receiptDateISO: null, 
        }
    }, 
    methods: {
        updateData(data){
            //console.log(data);
            this.incident[data.field]=data.value;
            this.$emit('updateData', data);
        }
    }
}
</script>

<style scoped>
    .row-pointer {
        cursor: default;
    }
</style>